<script setup>
import { computed } from 'vue'
import AppButton from '@/components/atoms/AppButton'
import { HELP_HUB_PANEL_ID, HELP_HUB_TOGGLE_ID } from '@/constants'

const props = defineProps({
  open: Boolean,
  // Support replies the dealer hasn't read. The old floating launcher carried this number;
  // with it gone, nothing else tells a dealer an agent answered.
  unread: { type: Number, default: 0 },
})

defineEmits(['toggle'])

// `default` is the header's own tint, so at rest only the icon shows.
const variant = computed(() => (props.open ? 'header' : 'default'))
</script>

<template>
  <AppButton
    :id="HELP_HUB_TOGGLE_ID"
    :variant="variant"
    class="relative w-9 shrink-0 -mx-1.5 md:mx-0"
    :class="{ 'border border-transparent': !open }"
    :aria-label="unread ? `Help Hub, ${unread} unread` : 'Help Hub'"
    :aria-expanded="open"
    :aria-controls="open ? HELP_HUB_PANEL_ID : undefined"
    @click="$emit('toggle')"
  >
    <Icon icon="heroicons:question-mark-circle" class="text-2xl shrink-0" />

    <!-- A dot, not a count: the header has no room for a number, and "something is waiting"
         is the whole message. The count itself is on the ticket's row in the panel. -->
    <span
      v-if="unread > 0 && !open"
      class="absolute right-1 top-1 size-2 rounded-full bg-red-500 ring-2 ring-white"
      aria-hidden="true"
    />
  </AppButton>
</template>
